import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class EmailValidators {
  /**
   * Validates one or more email addresses separated by commas.
   *
   * @returns A ValidatorFn that checks if the control's value contains valid email addresses.
   *          If any email address is invalid, it returns a validation error object with the key 'invalidEmail'.
   *          Otherwise, it returns null.
   */
  static emailValidator(): ValidatorFn {
    // https://github.com/angular/angular/blob/main/packages/forms/src/validators.ts#L146
    const emailRegex =
      /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || typeof control.value !== 'string') {
        return null;
      }

      const emails: string[] = control.value
        .split(',')
        .map((email: string) => email.trim());
      const invalidEmails = emails.filter(
        (email) => email && !emailRegex.test(email),
      );

      if (invalidEmails.length > 0) {
        return { invalidEmail: true };
      }

      return null;
    };
  }
}
